/*! Wi-plugins - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

+function ($) {
    'use strict';

    window.fileStore = new Map();

    const MAX_FILE_SIZE_MB = 10;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
    const MAX_FILES = 3;

    if (typeof DOMPurify !== 'undefined' && !window.__domPurifyHookAdded) {
        DOMPurify.addHook('afterSanitizeAttributes', function (node) {
            if (node.tagName === 'A') {
                node.setAttribute('target', '_blank');
                node.setAttribute('rel', 'noopener noreferrer');
            }
        });
        window.__domPurifyHookAdded = true;
    }

    var wiPlugins = window.wiPlugins;
    window.wiPlugins = {
        init: function () {
            wiPlugins.refresh();
            wiPlugins.flatpicker.init();
        },
        refresh: function () {
            wiPlugins.bootstrapSlider.init();
            wiPlugins.colorpicker.init();
            wiPlugins.fileButton.init();
            wiPlugins.iconpicker.init();
            wiPlugins.selectpicker.init();
            wiPlugins.summernote.init();
            wiPlugins.datetimepicker.init();
            wiPlugins.flatpicker.refresh();
            //wiPlugins.mediaelements.init();
        },
        fileButton: {
            init: function () {
                $(document).off('change', ':file').on('change', ':file', function () {
                    const input = $(this);
                    if (input.hasClass('file-upload-manager')) {
                        return;
                    }

                    const files = Array.from(this.files);
                    if (!files.length) {
                        return;
                    }
                    const form = input.closest('form')[0];
                    const $form = $(form);
                    const $metaInput = $form.find('.attached-files-meta');
                    let currentMeta = JSON.parse($metaInput.val() || '[]');

                    let filesInForm = window.fileStore.get(form) || [];
                    const newFiles = [];

                    const container = input.closest('.file-group');
                    const singleInfo = container.find('.file-info');
                    // If single file mode (.file-info exists), reset file store and metadata
                    if (singleInfo.length) {
                        filesInForm = [];
                        currentMeta = [];
                        window.fileStore.set(form, []);
                        $metaInput.val('[]');
                    }

                    // Validate oversized files
                    const oversizedFiles = files.filter(file => file.size > MAX_FILE_SIZE);
                    if (oversizedFiles.length) {
                        oversizedFiles.forEach(file => {
                            wiAlerts.add('warning', lang.media_file_too_large, sprintf(lang.media_file_too_large_description, file.name, MAX_FILE_SIZE_MB));
                        });
                        input.val('');
                        return;
                    }

                    // Check for duplicates
                    files.forEach(file => {
                        const isDuplicate = filesInForm.some(f => f.name === file.name && f.size === file.size);
                        if (isDuplicate) {
                            wiAlerts.add('warning', lang.media_duplicate_file, sprintf(lang.media_duplicate_file_description, file.name));
                        } else {
                            newFiles.push(file);
                        }
                    });

                    // Check total limit
                    if ((filesInForm.length + newFiles.length) > MAX_FILES) {
                        wiAlerts.add('warning', lang.media_files_limit, sprintf(lang.media_files_limit_description, MAX_FILES));
                        input.val('');
                        return;
                    }

                    // Update store and metadata
                    filesInForm = filesInForm.concat(newFiles);
                    window.fileStore.set(form, filesInForm);
                    currentMeta = currentMeta.concat(newFiles.map(f => ({name: f.name, size: f.size})));
                    $metaInput.val(JSON.stringify(currentMeta));

                    // Fire custom event for rendering
                    const numFiles = newFiles.length;
                    const filenames = newFiles.map(f => f.name);
                    input.trigger('fileselect', [numFiles, filenames, newFiles]);

                    input.val('');
                });

                $(document).off('fileselect').on('fileselect', ':file', function (event, numFiles, filenames, files) {
                    const input = $(this);
                    const container = input.closest('.file-group');
                    const singleInfo = container.find('.file-info');
                    const multiInfo = container.find('.files-info');

                    if (singleInfo.length) {
                        const log = numFiles > 1 ? sprintf(lang.media_files_selected, numFiles) : filenames[0];
                        singleInfo.text(log);
                        return;
                    }

                    let $appendTo;

                    const targetSelector = input.data('target');
                    if (targetSelector) {
                        $appendTo = $('.' + targetSelector);
                    } else {
                        const multiInfo = container.find('.files-info');
                        if (multiInfo.length) {
                            $appendTo = multiInfo;
                        } else if (input.hasClass('comment_file')) {
                            const $form = input.closest('form');
                            $appendTo = $form.find('.note-editable').next('.note-attached-files');
                            if (!$appendTo.length) {
                                $appendTo = $('<div class="note-attached-files"></div>');
                                $form.find('.note-editable').after($appendTo);
                            }
                        }
                    }

                    if ($appendTo) {
                        files.forEach(file => {
                            const $fileBlock = $(`
                                <span class="attached-file" contenteditable="false" data-filename="${file.name}" data-filesize="${file.size}">
                                    <i class="fa fa-paperclip"></i> ${file.name}
                                    <button type="button" class="remove-file" title="${sprintf(lang.media_remove_file, file.name)}">&times;</button>
                                </span>&nbsp;
                            `);
                            $appendTo.append($fileBlock);
                        });
                    }
                });

                $(document).on('click', '.attached-file .remove-file', function (e) {
                    e.preventDefault();
                    const $fileSpan = $(this).closest('.attached-file');
                    const $form = $fileSpan.closest('form');
                    wiPlugins.fileButton.removeAttachedFile($fileSpan, $form);
                });
            },

            removeAttachedFile($fileSpan, $form) {
                const filename = $fileSpan.data('filename');
                const filesize = $fileSpan.data('filesize');
                const form = $form[0];
                const $metaInput = $form.find('.attached-files-meta');

                let meta = JSON.parse($metaInput.val() || '[]');
                meta = meta.filter(f => !(f.name === filename && f.size == filesize));
                $metaInput.val(JSON.stringify(meta));

                const updatedFiles = (window.fileStore.get(form) || []).filter(f => !(f.name === filename && f.size == filesize));
                window.fileStore.set(form, updatedFiles);

                $fileSpan.remove();
            }
        },
        colorpicker: {
            init: function () {
                if ($('.colorpicker').length) {
                    $('.colorpicker').colorpicker();
                }
                if ($('.modal-colorpicker').length) {
                    $('.modal-colorpicker').colorpicker({format: 'rgba'});
                }
            }
        },
        datetimepicker: {
            init: function () {
                var faIcons = {
                    time: 'fa fa-clock-o',
                    date: 'fa fa-calendar',
                    up: 'fa fa-arrow-up',
                    down: 'fa fa-arrow-down',
                    previous: 'fa fa-arrow-left',
                    next: 'fa fa-arrow-right',
                    today: 'fa fa-crosshairs',
                    clear: 'fa fa-calendar-times-o',
                    close: 'fa fa-remove'
                };
                if ($('#due_date').length) {
                    $('#due_date').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: language,
                        icons: faIcons
                    });
                }
                if ($('.datepicker').length) {
                    $('.datepicker').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: language,
                        icons: faIcons
                    });
                }
                if ($('.datetimepicker').length) {
                    $('.datetimepicker').datetimepicker({
                        format: 'YYYY-MM-DD HH:mm',
                        locale: language,
                        icons: faIcons
                    });
                }
                if ($('.first-datetimepicker').length && $('.second-datetimepicker').length) {
                    $('.first-datetimepicker').datetimepicker({
                        format: 'YYYY-MM-DD HH:mm',
                        locale: language,
                        icons: faIcons
                    });
                    $('.second-datetimepicker').datetimepicker({
                        format: 'YYYY-MM-DD HH:mm',
                        locale: language,
                        icons: faIcons,
                        useCurrent: false
                    });
                    $(".first-datetimepicker").on("dp.change", function (e) {
                        $('.second-datetimepicker').data("DateTimePicker").minDate(e.date);
                    });
                    $(".second-datetimepicker").on("dp.change", function (e) {
                        $('.first-datetimepicker').data("DateTimePicker").maxDate(e.date);
                    });
                }
            }
        },
        flatpicker: {
            init: function () {
                var fpLocale = (language && language !== 'en') ? language : 'default';
                if ($('.flat-datepicker').length) {
                    $('.flat-datepicker').flatpickr({
                        locale: fpLocale,
                        dateFormat: "Y-m-d"
                    });
                }
                if ($('.flat-datetimepicker').length) {
                    $('.flat-datetimepicker').flatpickr({
                        locale: fpLocale,
                        enableTime: true,
                        time_24hr: true,
                        dateFormat: "Y-m-d H:i"
                    });
                }
            },
            refresh: function () {}
        },
        iconpicker: {
            init: function () {
                if ($('.iconpicker').length) {
                    $('.iconpicker').iconpicker();
                }
            }
        },
        sortable: {
            init: function () {
                document.querySelectorAll('.sortable').forEach(function (el) {
                    if (!el._sortable) {
                        el._sortable = new Sortable(el, { animation: 150 });
                    }
                });
            }
        },
        selectpicker: {
            init: function () {
                if ($('.selectpicker').length) {
                    $('.selectpicker').selectpicker();
                }
            }
        },
        summernote: {
            init: function () {
                if ($('.summernote').length) {
                    var langCode = language + '-' + language.toUpperCase();
                    $('.summernote').each(function () {
                        const $editor = $(this); // ✅ the actual <textarea class="summernote">

                        $editor.summernote({
                            lang: langCode,
                            placeholder: lang.editor_placeholder,
                            toolbar: [
                                // [groupName, [list of button]]
                                ['style', ['bold', 'italic', 'underline']], //, 'clear'
                                // ['font', ['strikethrough', 'superscript', 'subscript']],
                                ['para', ['ul', 'ol']],
                                ['insert', ['link']]
                            ],
                            dialogsInBody: true,
                            keyMap: {
                                pc: {
                                    'CTRL+ENTER': null
                                },
                                mac: {
                                    'CMD+ENTER': null
                                }
                            },
                            callbacks: {
                                onInit: function () {
                                    if ($editor.data('show-default')) {
                                        return;
                                    }
                                    const $editorSibling = $editor.siblings('.note-editor');
                                    const $toolbar = $editorSibling.find('.note-toolbar');
                                    const $editable = $editorSibling.find('.note-editable');

                                    // Move toolbar after editable area
                                    $toolbar.insertAfter($editable);

                                    // Add custom file attachment icon
                                    const customFileButton = `
                                        <div class="note-btn-group btn-group note-btn-show-always note-file">
                                            <label class="note-btn btn btn-default btn-sm note-btn-file" tabindex="-1" title="${lang.editor_attach_files}" data-toggle="tooltip-editor">
                                                <i class="fa fa-paperclip"></i>
                                                <input type="file" name="userfiles[]" class="comment_file" multiple/>
                                            </label>
                                        </div>
                                        <div class="note-btn-group btn-group note-btn-show-always pull-right">
                                            <button type="submit" class="note-btn btn btn-sm note-btn-send btn-success" tabindex="-1" title="${lang.editor_send_message}" data-toggle="tooltip-editor">
                                                <i class="fa fa-paper-plane"></i>
                                            </button>
                                        </div>
                                    `;
                                    $toolbar.append(customFileButton);
                                    $("[data-toggle='tooltip-editor']").tooltip({
                                        container: 'body',
                                        trigger: 'hover',
                                        placement: 'bottom'
                                    });
                                    $toolbar.find('[data-original-title]').tooltip('destroy').tooltip({
                                        container: 'body',
                                        trigger: 'hover',
                                        placement: 'bottom'
                                    });

                                    $editable.on('keydown', function (e) {
                                        if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                                            e.preventDefault();
                                            $editorSibling.find('.note-btn-send').trigger('click');
                                        }
                                    });
                                },
                                onFocus: function () {
                                    if ($editor.summernote('isEmpty')) {
                                        $editor.summernote('code', '');
                                    }
                                },
                                onDialogShown: function () {
                                    setTimeout(function () {
                                        $('.modal.note-modal').each(function () {
                                            $(this).find('.modal-footer .btn-primary')
                                                    .removeClass('btn-primary')
                                                    .addClass('btn-success btn-sm');
                                        });
                                    }, 50);
                                },
                                onPaste: function (e) {
                                    e.preventDefault();
                                    const clipboardData = (e.originalEvent || e).clipboardData;
                                    let html = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

                                    let content;

                                    if (html.includes('<html')) {
                                        const parser = new DOMParser();
                                        const doc = parser.parseFromString(html, 'text/html');
                                        content = doc.body ? doc.body.innerHTML : html;
                                    } else {
                                        content = html;
                                    }
                                    content = wiPlugins.summernote.convertHeadersToBold(content);

                                    const cleanHTML = DOMPurify.sanitize(content, {
                                        ALLOWED_TAGS: [
                                            'p', 'br', 'b', 'strong', 'i', 'em',
                                            'u', 'ul', 'ol', 'li', 'a', 'span'
                                        ],
                                        ALLOWED_ATTR: ['href', 'target', 'rel'],
                                        FORBID_TAGS: ['img', 'style', 'link', 'time'],
                                        FORBID_ATTR: ['style', 'class']
                                    });
                                    const range = $editor.summernote('createRange');                                    
                                    if (range && !range.isCollapsed()) {
                                        range.deleteContents();
                                    }
                                    $editor.summernote('pasteHTML', `<div class="pasted-wrapper">${cleanHTML}</div>`);
                                }
                            }
                        });
                    });
                }
            },
            convertHeadersToBold(html) {
                const temp = document.createElement('div');
                temp.innerHTML = html;

                temp.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(header => {
                    const bold = document.createElement('strong');
                    bold.innerHTML = header.innerHTML;

                    const p = document.createElement('p');
                    p.appendChild(bold);

                    header.replaceWith(p);
                });

                return temp.innerHTML;
            }
        },
        bootstrapSlider: {
            init: function () {
                if ($('.input-slider').length) {
                    $('.input-slider').ionRangeSlider({
                        skin: "square"
                    });
                }
            }
        },
        mediaelements: {
            init: function () {
                if ($("video").length || $("audio").length) {
                    var options = {
                        iconUrl: '{imgPath}/plyr.svg'
                    };
                    plyr.setup(options);
                }
            }
        }
    };
    $(function () {
        wiPlugins = window.wiPlugins;
        wiPlugins.init();
    });
}(jQuery);
